import ApiService from "./ApiService";
import utilityService from "./utilityService";
const getAll = async () => {
  debugger;
  const url = "/GetAllSetupRunCharges";
  try {
    const result = await ApiService.get(url);

    if (result.data) return result.data;
  } catch (err) {
    console.log("ApiError", err.message);
  }
  return null;
};

const getOne = async (id) => {
  const url = `/GetSetupRunCharges?Id=${id}`;
  try {
    const result = await ApiService.get(url);
    if (result.data) return result.data;
  } catch (err) {
    console.log("ApiError", err.message);
  }
  return null;
};

const update = async (data) => {
  const url = "/UpdateSetupRunCharges?" + utilityService.queryString(data);
  try {
    const result = await ApiService.post(url);
    if (result.status === 200)
      return {
        success: true,
        message: result.data,
      };
  } catch (err) {
    console.log("ApiError", err.message);
    return {
      success: false,
      message: "Failed to update deco method",
    };
  }
};

const add = async (data) => {
  const url = "/AddSetupRunCharges?" + utilityService.queryString(data);
  try {
    const result = await ApiService.post(url);
    if (result.status === 200)
      return {
        success: true,
        message: result.data,
      };
  } catch (err) {
    console.log("ApiError", err.message);
    return {
      success: false,
      message: "Failed to add new deco method",
    };
  }
};

const remove = async (id) => {
  const url = "/DeleteSetupRunCharges?Id=" + id;

  try {
    const result = await ApiService.post(url);
    if (result.status === 200)
      return {
        success: true,
        message: result.data,
      };
  } catch (err) {
    console.log("ApiError", err.message);
    return {
      success: false,
      message: "Failed to remove deco method",
    };
  }
};

export default {
  getAll,
  getOne,
  update,
  add,
  remove,
};
